<template>
  <div v-if="order" class="order-detail-root">
    <div class="header">
      <p>{{ order.tradeState | getMarginTradeState }}</p>
      <img v-if="tradeStateImageUrl" :src="tradeStateImageUrl" alt width="46px" height="46px" />
    </div>
    <div class="cell-container">
      <template v-for="item in cellOrderList">
        <div :key="item.label" :class="{ cell: true, 'bottom-divider': true }" v-if="item.value">
          <div class="title">{{ item.label }}</div>
          <div :class="'content ' + item.className">
            <span v-if="item.before">{{ item.before }}</span>
            <span>{{ item.value }}</span>
            <span v-if="item.after">{{ item.after }}</span>
          </div>
        </div>
      </template>
    </div>

    <div class="bottom-bar">
      <div class="btn" v-if="canMarginRefund(order)" @click="clickRefund(order)">退款</div>
    </div>
    <refund-dialog
      v-model="refundObj.showDialog"
      :order="refundObj.selectOrder"
      @refund-success="updateOrder"
      :type="44"
    ></refund-dialog>
  </div>
</template>
<script>
import { getOrderDetail } from '@/api/orderMargin';
import { formatDateTime } from '@/utils/index';
import { getOrderPayStateStr } from '@/views/order/orderTool';
import { getMarginTradeState, canMarginRefund } from '@/views/order/margin/marginTool';
import { Toast } from 'vant';
import mixinRefund from '@/views/order/mixin/refund';
export default {
  filters: { getMarginTradeState },
  mixins: [mixinRefund],
  data() {
    return {
      cellOrderList: [],
      id: '',
      order: null,
      loading: false,
      finished: false,
      tradeStateImageUrl: null,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.requestData();
  },
  methods: {
    canMarginRefund,
    requestData: function() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      getOrderDetail({
        id: this.id,
      })
        .then(response => {
          Toast.clear();
          this.timeStamp = response.timestamp;
          this.updateOrder(response.data);
        })
        .catch(response => {
          Toast.clear();
          Toast.fail({
            message: response.message,
          });
        });
    },
    updateOrder: function(o) {
      this.order = o;
      switch (o.tradeState) {
        case 0: //代付款
          break;
        case 10: // 冻结中
          this.tradeStateImageUrl =
            'https://img.zai-art.com/zaiart/saas/image/md/8fc9eeb7f5b0c11373c917b3ea76cde8.png';
          break;
        case 20: // 违约
          this.tradeStateImageUrl =
            'https://img.zai-art.com/zaiart/saas/image/md/dc8d0f4c0b7c1f42acbd67b5e1d3d07b.png';
          break;
        case 30: // 退回
          this.tradeStateImageUrl =
            'https://img.zai-art.com/zaiart/saas/image/md/f153046e5cb303fa7821f6b46dcf338c.png';
          break;
        default:
          this.tradeStateImageUrl =
            'https://img.zai-art.com/zaiart/saas/image/md/dc8d0f4c0b7c1f42acbd67b5e1d3d07b.png';
          break;
      }
      this.cellOrderList = [
        {
          label: '订单编号',
          value: o.id,
        },
        {
          label: '下单时间',
          value: formatDateTime(o.createTime),
        },
        {
          label: '支付时间',
          value: formatDateTime(o.payTime),
        },
        {
          label: '支付状态',
          value: getOrderPayStateStr(o.payState),
        },
        {
          label: '完成时间',
          value: formatDateTime(o.completeTime),
        },
        {
          label: '退款时间',
          value: formatDateTime(o.refundTime),
        },
        {
          label: '保证金状态',
          value: getMarginTradeState(o.tradeState),
        },
        {
          label: '退款备注',
          value: o.refundBody,
        },
        {
          label: '保证金金额',
          value: `${o.mainCurrency ? o.mainCurrency.mark : '¥'} ${o.marginAmount}`,
        },
      ];
    },
  },
};
</script>
<style scoped src="../order-detail.css"></style>
<style scoped>
.header {
  height: 90px;
  background: #000 url('../../../assets/img/margin-order-detail-header.png') center/cover;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header p {
  height: 90px;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 90px;
}
</style>
